import { DimmedText } from 'components/common/styled/common-styled';
import { useBrandCurrency } from 'hooks/useBrandCurrency';
import usePoints from 'hooks/usePoints';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { currencyFormat } from 'utils';
import { TaxV3 } from '@kouto/types';

interface CartSummaryItemPriceProps {
  hidePrice: boolean;
  isPrivateBooking: boolean;
  price: number;
  selectedNumber: number;
  isPayingWithPoints?: boolean;
  taxes?: TaxV3[];
}
const CartSummaryItemPrice = ({
  hidePrice,
  isPrivateBooking,
  price,
  selectedNumber,
  isPayingWithPoints,
  taxes,
}: CartSummaryItemPriceProps) => {
  const { t } = useTranslation();
  const currency = useBrandCurrency();
  const priceWithTaxes =
    price +
    (taxes?.reduce((acc, tax) => {
      if ('percentage' in tax && !tax.includedInPrice) {
        return acc + (price * (tax.percentage ?? 0)) / 100;
      }
      return acc;
    }, 0) || 0);
  const { count } = usePoints(isPayingWithPoints ? priceWithTaxes : price);

  const selectedPrice = isPayingWithPoints
    ? t('pointsWithCount', { count })
    : currencyFormat(currency)(price);

  if (hidePrice) return null;

  if (price === 0 && !hidePrice) {
    return (
      <DimmedText size={14} className="cart-summary-item-price">
        {t('complimentary')}
        {!isPrivateBooking && ` x ${selectedNumber}`}
      </DimmedText>
    );
  }
  return (
    <DimmedText size={14} className="cart-summary-item-price">
      {selectedPrice}
      {!isPrivateBooking && ` x ${selectedNumber}`}
    </DimmedText>
  );
};

export default CartSummaryItemPrice;
